import { FC } from 'react'
import JsxParser from 'react-jsx-parser'
// @ts-ignore
import * as CWS from 'cms-web-styleguide'
import { CwsA } from 'cms-web-styleguide/dist/components/CwsA/CwsA'
import { CwsSection } from 'cms-web-styleguide/dist/components/CwsSection/CwsSection'
import ProductsCollection from '@components/common/ProductsCollection'
import W2Products from '@components/common/W2Products'
import MediaQuery from '@components/cws/MediaQuery'
interface CwsAProps {
  href: string
  children: React.ReactNode
  locale?: string
  catalogId?: string | string[]
  [key: string]: any
}

interface CwsSection {
  id: string
  className: string
  children: React.ReactNode
  productListIsEmpty: boolean
  [key: string]: any
}
interface BannerWrapperProps {
  jsxString: string
  locale?: string
  catalogId?: string | string[]
  productListIsEmpty: boolean
}

export const ModifiedCwsSection: FC<CwsSection> = ({ id, productListIsEmpty, children, ...rest }) => {
  if (id === 'dynamic' && productListIsEmpty) return null
  return <CwsSection {...{ ...rest, id }}>{children}</CwsSection>
}

export const ModifiedCwsA: FC<CwsAProps> = ({ href, children, locale, catalogId, ...rest }) => {
  const newHref = catalogId
    ? `/${locale}/${catalogId}${href.startsWith('/') ? '' : '/'}${href}`
    : `/${locale}${href.startsWith('/') ? '' : '/'}${href}`

  return <CwsA {...{ ...rest, href: newHref }}>{children}</CwsA>
}
export const BannerWrapper: FC<BannerWrapperProps> = ({ jsxString, locale, catalogId, productListIsEmpty }) => {
  const components = {
    ...CWS,
    CwsA: (props: CwsAProps) => <ModifiedCwsA {...{ locale, catalogId, ...props }} />,
    CwsSection: (props: CwsSection) => <ModifiedCwsSection {...{ ...props, productListIsEmpty }} />,
    ProductsCollection,
    W2Products,
    MediaQuery,
  }

  // @ts-ignore
  const parserNode = <JsxParser renderInWrapper={false} bindings={{}} components={components} jsx={jsxString} />

  return <>{parserNode}</>
}
